import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { uniqWith as _uniqWith } from 'lodash';

import { Address, RiskModel } from '@amfam/policy/models';

import { KydSignUp } from '../../../core/store/programs/kyd';
import { AddressCompare } from '../../../shared';

@Component({
  selector: 'app-kyd-ship-tos',
  templateUrl: './kyd-ship-tos.component.html',
  standalone: false
})
export class KydShipTosComponent implements OnChanges {
  @Input() kydForm: UntypedFormGroup;
  @Input() risks: RiskModel[];
  @Output() addressSelection = new EventEmitter<KydSignUp[]>();

  public shipTos = new Array<Address>();
  public loaded = false;
  private addresses: { [key: string]: KydSignUp } = {};

  ngOnChanges() {
    this.loaded = false;
    if (this.risks) {
      const tempShipTos = this.risks.map(risk => risk.address);
      this.shipTos = _uniqWith(tempShipTos, AddressCompare.equal).sort();
      this.loaded = true;
    }
  }

  public addressChange(address: KydSignUp) {
    this.addresses[address.riskModel.id] = address;
    const signUpArray = new Array<KydSignUp>();
    for (const key in this.addresses) {
      if (this.addresses.hasOwnProperty.call(key)) {
        signUpArray.push(this.addresses[key]);
      }
    }
    this.addressSelection.emit(signUpArray);
  }
}
